// extracted by mini-css-extract-plugin
export default {"wrapper":"LinearProgress_wrapper__0ZxyI","spacing":"LinearProgress_spacing__ysC9a","text":"LinearProgress_text__c4FV5","default-style":"LinearProgress_default-style__ijMcw"};